export const ADD_CONFLICT = 'ADD_CONFLICT';

export const addConflict = (firstContext, secondContext, typeConflict) => ({
  type: ADD_CONFLICT,
  firstContext,
  secondContext,
  typeConflict,
});
